import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const ConfirmationModal = ({
                                     show,
                                     onHide,
                                     onConfirm,
                                     title,
                                     subtitle,
                                     message = "Are you sure you want to delete this item?",
                                     warningText = "This action cannot be undone.",
                                     confirmButtonText = "Delete",
                                     cancelButtonText = "Cancel"
                                 }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="delete-confirm-modal"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="delete-confirm-modal">
                    <FontAwesomeIcon icon={faTrash} className="text-danger me-2" />
                    Confirm Delete
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <p className="mb-3">
                        {message}
                    </p>
                    {(title || subtitle) && (
                        <div className="bg-light p-3 rounded mb-3">
                            {title && <strong>{title}</strong>}
                            {subtitle && (
                                <>
                                    <br />
                                    <small className="text-muted">{subtitle}</small>
                                </>
                            )}
                        </div>
                    )}
                    <p className="text-danger small mb-0">
                        <FontAwesomeIcon icon={faTimesCircle} className="me-1" />
                        {warningText}
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button variant="outline-secondary" onClick={onHide}>
                    {cancelButtonText}
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    <FontAwesomeIcon icon={faTrash} className="me-1" />
                    {confirmButtonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
